import React from 'react';
import { Routes, Route, useLocation } from 'react-router';
import Welcome from "../pages/Welcome";
import Resume from "../pages/Resume";
import Portfolio from "../pages/Portfolio";
import { AnimatePresence } from "framer-motion";

function AnimateRoutes () {
    const location = useLocation();

    return (
        <AnimatePresence>
            <Routes location={location} key={location.pathname}>
                <Route path="/" element={<div></div>} />
                <Route path="/welcome" element={<Welcome />} />
                <Route path="/resume" element={<Resume />} />
                <Route path="/portfolio" element={<Portfolio />} />
            </Routes>
        </AnimatePresence>
    );
}

export default AnimateRoutes;